<template>
  <v-app>
    <!-- <transition name='router-animate' enter-active-class="animated flipInX" leave-active-class="animated bounceOut"> -->
    <transition name="router-animate">
      <router-view/>
    </transition>
    <div class="text-xs-center">
      <Navbar/>
    </div>
    <Chat/>
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Chat from "./components/Chat.vue";
export default {
  components: { Navbar, Chat },
  data: () => ({
    drawer: null
  }),
  props: {
    source: String
  }
};
</script>

<style>
@import url("https://cdnjs.cloudflare.com/ajax/libs/animate.css/3.7.0/animate.css");
html {
  overflow-y: auto;
}
.router-animate-enter-active {
  animation: coming 0.7s;
  animation-delay: 0.5s;
  opacity: 0;
}
.router-animate-leave-active {
  animation: going 1s;
}

@keyframes going {
  from{
    transform: translateX(0);
  }
  to{
    transform: translateX(-50px);
    opacity: 0;
  }
}

@keyframes coming {
  from{
    transform: translateX(0);
  }
  to{
    transform: translateX(-50px);
    opacity: 0;
  }
}
</style>
